export const INCIDENT_CATEGORIES = [
    { id: "wrong_result", label: "Gave the wrong answer" },
    { id: "broken", label: "Something didn't work" },
    { id: "confusing", label: "Confusing or hard to use" },
    { id: "missing", label: "Missing something I needed" },
    { id: "slow", label: "Too slow" },
    { id: "other", label: "Something else" },
];
